const logFunction = (...args) => {
    let config = {
        background: "#222",
        title: "shapes"
    }

    if(typeof args[0] === 'object' && !(!args[0].title && !args[0].background)){
        config = {
            ...config,
            ...args[0]
        };

        args.shift();
    }

    let message = [`%c${config.title}`, `border-radius: 2px; color: #fff; font-weight: bold; background: ${config.background}; padding: 2px 4px`];
    
    if(config.subtitle){
        message = [
            `%c${config.title}%c${config.subtitle}`,
            `border-radius: 2px; color: #fff; font-weight: bold; background: ${config.background}; padding: 2px 4px`,
            `border-radius: 2px; color: #000; font-weight: 500; margin-left: 4px; background: #eee; padding: 2px 4px`
        ]
    }
    
    console.log(...message, ...args);
}

export default { 
    message : logFunction,
    error(...args){
        logFunction({title: "shapes:error", subtitle: "", background: "#FF5630"}, ...args);
    },
    event(...args){
        const subtitle =  args[0];
        args.shift();
        logFunction({title: "shapes:event", subtitle: subtitle}, ...args);
    },
    success(...args){
        logFunction({background: "#36B37E"}, ...args);
    }
}